import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { CompanyBuyerCompanyDto, companyBuyerCompanyValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface BuyerCompanyAddEditDialogProps {
  initialValues: CompanyBuyerCompanyDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function BuyerCompanyAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: BuyerCompanyAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={companyBuyerCompanyValidationSchema}
        onSubmit={(values, formickHelpers) => {
          onSave(values)
          formickHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Buyer Company</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.buyerCode && errors.buyerCode)}
                      helperText={touched.buyerCode && errors.buyerCode}
                      label='Buyer Code'
                      name='buyerCode'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.buyerCode}
                    />
                  </Grid>

                  {/* <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.dealerNumber && errors.dealerNumber)}
                      helperText={touched.dealerNumber && errors.dealerNumber}
                      label='Dealer #'
                      name='dealerNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.dealerNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.irsNumber && errors.irsNumber)}
                      helperText={touched.irsNumber && errors.irsNumber}
                      label='IRS #'
                      name='irsNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.irsNumber}
                    />
                  </Grid> */}

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      || All fields are required.|| Buyer Code must be 3 characters. ||
                      {/* The Dealer # and IRS # values are used
                      in the Title Application process. || */}
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
